import React, { useEffect, useState } from 'react';

const MODAL_CONTENT = {
  required: {
    title: 'Log in to continue',
    description:
      'Please log in to your account to access this feature and keep creating with the Twygs community.'
  },
  optional: {
    title: 'Join the Twygs community',
    description:
      'Be part of a creative community. Create your account to start posting, saving and connecting with creators.'
  }
};

export type UnauthorizedType = 'required' | 'optional';

export default function UnauthorizedModal() {
  const [open, setOpen] = useState(false);
  const [type, setType] = useState<UnauthorizedType>('optional');

  useEffect(() => {
    function handler(e) {
      setType(e.detail?.type ?? 'optional');
      setOpen(true);
    }

    window.addEventListener('twygs:unauthorized', handler);
    return () => window.removeEventListener('twygs:unauthorized', handler);
  }, []);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-[10000]"
      role="dialog"
      aria-modal="true"
      onClick={(e) => {
        // close when clicking backdrop only
        if (e.target === e.currentTarget) setOpen(false);
      }}
    >
      <div className="bg-white p-6 rounded-lg max-w-lg w-[90%] shadow-lg">
        <h3 className="text-xl font-extrabold mb-2">{MODAL_CONTENT[`${type}`]?.title}</h3>
        <p className="text-sm text-slate-600 mb-4">{MODAL_CONTENT[`${type}`]?.description}</p>
        <div className="flex justify-between gap-3">
          <a
            href={`/authen/signup?from=${window.location.href}`}
            target="_self"
            className="px-[14px] py-[6px] text-growth-green-500 cursor-pointer border-[2px] border-growth-green-500 rounded-[8px] text-sm font-black whitespace-nowrap hover:opacity-80 w-full text-center"
          >
            Sign Up
          </a>
          <a
            href={`/authen/login?from=${window.location.href}`}
            target="_self"
            className="cursor-pointer bg-growth-green px-[14px] py-[8px] text-center !rounded-[8px] text-white text-sm font-black hover:opacity-80 w-full"
          >
            Log In
          </a>
        </div>
      </div>
    </div>
  );
}
